export default __webpack_public_path__ + "static/media/ic_arrow_triangle_up_white.98c72fe4.svg";